<script lang="ts">
 import { onMount } from "svelte"
 import { LetterClue } from "./match.ts"
 import { game, guesses, wordlen } from "./game.ts"
 import { shaker } from "./state.ts"

 const clueClasses = {
     [LetterClue.NotHere]: "not-here",
     [LetterClue.Exact]: "exact",
     [LetterClue.Present]: "present",
     [LetterClue.Unknown]: "unknown"
 };

 const clueFills = {
     [LetterClue.Unknown]: "transparent",
     [LetterClue.NotHere]: "#b7a38d", //"#3f3f3f",
     [LetterClue.Present]: "#e3b23e", //"orange",
     [LetterClue.Exact]: "forestgreen", //"green",
 };

 const clueTextFills = {
     [LetterClue.Unknown]: '#000',
     [LetterClue.NotHere]: '#fff',
     [LetterClue.Present]: '#fff',
     [LetterClue.Exact]: '#fff',
 };

 const clueStrokes = { ...clueFills, [LetterClue.Unknown]: "#757575" };
 
 let square = 20

 let maxy = 6 * square + 2 // 6 * 20 + 2 = 122 virtual pixels
 let maxx = 5 * square + 2 + 10
 let pos = new Array(guesses);
 for (let i = 0; i < guesses; i++) {
     pos[i] = new Array(wordlen);
     for (let idx = 0; idx < wordlen; idx++) {
         pos[i][idx] = [square * idx + 7, square * i + 2, square * idx + Math.ceil((square >> 1)) + 6, square * (i + 1) - 3.5];
     }
 }
 let data = new Array(guesses).fill(0).map(() => (new Array(wordlen).fill(0).map(() => ({
     letter: " ",
     clueClass: "unknown",
     fill: "",
     stroke: "",
     textFill: ""
 }))));

 $: shakingIdx = $shaker ? $game.currentRow : -1;

 $: {
     let cur = $game.currentRow
     for (let row = Math.max(cur - 1, 0); row < data.length; row++) {
         let rowClues = $game.clues && $game.clues[row] || [];
         let rowdata = data[row];

         for (let i = 0; i < rowdata.length; i++) {
             let clue = rowClues[i] || LetterClue.Unknown
             let next = row === cur && (i === $game.firstEmpty());

             rowdata[i].letter = $game.letters[row][i];
             rowdata[i].clueClass = clueClasses[clue];
             rowdata[i].fill = clueFills[clue];
             rowdata[i].stroke = next ? "#333" : clueStrokes[clue];
             rowdata[i].next = next;
             rowdata[i].textFill = clueTextFills[clue];
         }
         data = data
     }
 }

 let viewBox = `0 0 ${maxx} ${maxy}`

 let vh = (window.innerHeight) / 100;
 let availableForBoard = 60 * vh - 40;
 let ratio = availableForBoard/maxy;

 onMount(() => {
     const resizer = () => {
         vh = (window.innerHeight) / 100;
         availableForBoard = 60 * vh - 40;
         ratio = availableForBoard/maxy;
     };
     window.addEventListener('resize', resizer)
     return () => {
         window.removeEventListener('resize', resizer);
     };
 });

 $: height = Math.floor(maxy * ratio);
</script>

<div class="board">
    <svg class="board_svg" viewBox={viewBox} height={height}>
        {#each data as lat, ri}
            <g class:shake={shakingIdx === ri}>
                {#each lat as l, li}
                    <rect x={pos[ri][li][0]} y={pos[ri][li][1]} class={"letter " + l.clueClass} stroke={l.stroke} class:next={l.next} width="18" height="18" fill={l.fill} stroke-width="0.5" />
                    <text fill={l.textFill} x={pos[ri][li][2]} y={pos[ri][li][3]} height={square} textLength={square} class={"letter " + l.clueClass}>
                        {l.letter}
                    </text>
                {/each}
            </g>
        {/each}
    </svg>
</div>

<style>
 :global(.board) {
     position: relative;
     padding-top: 8px;
     padding-bottom: 8px;
     max-width: 100vw;
     font-size: .8em;
     display: inline-flex;

     flex-direction: column;
     justify-content: center;
     transform: translate3d(0,0,1);
 }

 .letter {
     font-size: 14px;
     paint-order: stroke fill;
     text-anchor: middle;
     font-weight: 750;
     text-transform: uppercase;
 }

 .shake {
     animation-name: shake-anim;
     animation-timing-function: ease;
     animation-duration: 0.25s;

 }

 @keyframes shake-anim {
     0% {
         transform: translateX(0);

     }
     10% {
         transform: translateX(-3px);
     }
     45% {
         transform: translateX(2px);
     }
     75% {
         transform: translateX(-3px);
     }
     90% {
         transform: translateX(0);
     }

 }
</style>
